"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Piece_1 = require("~/chess/Piece");
const store_1 = require("~/front/store");
let TopMenu = class TopMenu extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.game = store_1.store.state.game;
    }
    get winner() {
        return this.game.isCheckMate !== false ? Piece_1.Color[this.game.oppositeTurn] : undefined;
    }
    get turn() {
        return Piece_1.Color[this.game.currentTurn];
    }
};
TopMenu = __decorate([
    vue_property_decorator_1.Component
], TopMenu);
exports.default = TopMenu;
